const routes = [
    {
        path: "/mentora/out/of/country/request-form",
        component: () => import("../pages/student/RequestForm.vue"),
        meta: {
            isAuthenticated: true,
            permission: "studentoutofcountryrequest_studentform"
        }
    },
    {
        path: "/mentora/out/of/country/requests",
        component: () => import("../pages/admin/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "studentoutofcountryrequest_index"
        }
    },
    {
        path: "/mentora/out/of/country/request-detail/:id",
        component: () => import("../pages/admin/Show.vue"),
        meta: {
            isAuthenticated: true,
            permission: "studentoutofcountryrequest_show"
        }
    },
];

export default routes;
